<template>
  <div>
    <com-dialog :visible.sync="visible" width="1100px" :title="titleMap[type]">
      <el-form :model="form" :rules="rulesFixed" ref="ruleForm" label-width="140px" :disabled="type === 'check'">
        <el-form-item label="收费规则" prop="ruleType">
          <el-select v-model="form.ruleType" @change="changeRuleType">
            <el-option label="充电" :value="1" />
            <el-option label="超时占用" :value="2" />
          </el-select>
        </el-form-item>
        <template v-if="form.ruleType === 1">
          <div class="flex items-center">
            <el-form-item style="width: 50%" label="名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 50%" label="收费类型" prop="type">
              <el-select v-model="form.type">
                <el-option label="服务费" :value="1" />
                <el-option label="电费+服务费" :value="2" />
                <el-option label="电费+固定服务费" :value="3" />
              </el-select>
            </el-form-item>
          </div>
          <div class="flex items-center">
            <el-form-item style="width: 50%" label="单次充电费用" prop="singelCharge">
              <el-input v-model="form.singelCharge">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 50%" label="计费方式" prop="powerType" v-if="[1, 2].indexOf(form.type) !== -1">
              <el-select v-model="form.powerType">
                <el-option label="最大功率收费" :value="1" />
                <el-option label="平均功率收费" :value="2" />
              </el-select>
            </el-form-item>
          </div>
          <div class="flex items-center">
            <el-form-item style="width: 50%" label="充电电费" prop="electricCharge" v-if="[2, 3].indexOf(form.type) !== -1">
              <el-input v-model="form.electricCharge" @input="handleElectricChargeInput">
                <template slot="append">元/度</template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 50%" label="服务费" prop="serviceCharge" v-if="[3].indexOf(form.type) !== -1">
              <el-input v-model="form.serviceCharge">
                <template slot="append">元/度</template>
              </el-input>
            </el-form-item>
          </div>
          <template v-if="[1, 2].indexOf(form.type) !== -1">
            <el-button style="margin: 0 0 20px 30px" type="primary" size="mini" @click="handleAddPlans">添加功率</el-button>
            <div v-for="(item, index) in form.chargePlanPowerBeanList" :key="index">
              <el-row>
                <el-col :span="10">
                  <div class="form_item flex items-center">
                    <div class="label">功率</div>
                    <div class="flex items-center">
                      <el-input v-model="item.minPower" style="width: 180px">
                        <template slot="append">W</template>
                      </el-input>
                      <div class="mlr-5px">-</div>
                      <el-input v-model="item.maxPower" style="width: 180px">
                        <template slot="append">W</template>
                      </el-input>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="form_item flex items-center">
                    <div class="label">金额</div>
                    <el-input v-model="item.price" style="width: 180px">
                      <template slot="append">元/小时</template>
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="2" v-if="type !== 'check'">
                  <div class="flex items-center justify-center h-35px">
                    <i class="el-icon-circle-plus" v-if="index === 0" @click="handleAddPlans"></i>
                    <i class="el-icon-remove" v-else @click="handleRemove(index)"></i>
                  </div>
                </el-col>
              </el-row>
            </div>
          </template>
        </template>

        <template v-if="form.ruleType === 2">
          <div class="flex items-center">
            <el-form-item style="width: 50%" label="名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 50%" label="收费类型" prop="type">
              <el-select v-model="form.type">
                <el-option label="计时" :value="4" />
              </el-select>
            </el-form-item>
          </div>
          <div class="flex items-center">
            <el-form-item style="width: 50%" label="免费时长" prop="freeDuration">
              <el-input v-model="form.freeDuration">
                <template slot="append">小时</template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 50%" label="收费上限" prop="chargeUpperLimit">
              <el-input v-model="form.chargeUpperLimit">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="flex items-center">
            <el-form-item style="width: 50%" label="计时费用" prop="chargePrice">
              <el-input v-model="form.chargePrice">
                <template slot="append">元/小时</template>
              </el-input>
            </el-form-item>
          </div>
        </template>
      </el-form>
      <div class="flex items-center justify-end mt-15px">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { addFeeStandardApi, updateFeeStandardApi, feeStandardDetailApi } from '@/api/fee-standards'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      title: '新增',
      titleMap: {
        created: '新增',
        edit: '编辑',
        check: '查看'
      },
      type: '',
      form: {},
      rules: {
        ruleType: [{ required: true, message: '请选择收费规则', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择收费类型', trigger: 'blur' }],
        singelCharge: [{ required: true, message: '请输入单次充电费用', trigger: 'blur' }],
        powerType: [{ required: true, message: '请选择计费方式', trigger: 'blur' }],
        electricCharge: [{ required: true, message: '请输入充电电费', trigger: 'blur' }],
        serviceCharge: [{ required: true, message: '请输入服务费', trigger: 'blur' }],

        freeDuration: [{ required: true, message: '请输入免费时长', trigger: 'blur' }],
        chargeUpperLimit: [{ required: true, message: '请输入收费上限', trigger: 'blur' }],
        chargePrice: [{ required: true, message: '请输入计时费用', trigger: 'blur' }],
      },
    }
  },
  computed: {
    // 使用 rulesFixed 对 electricCharge 增加强校验，不改变原始 rules 结构
    rulesFixed() {
      const base = this.rules || {}
      return {
        ...base,
        electricCharge: [
          { required: true, message: '请输入充电电费', trigger: 'blur' },
          { validator: (rule, value, callback) => this.validateElectricChargeRule(rule, value, callback), trigger: 'change' },
          { validator: (rule, value, callback) => this.validateElectricChargeRule(rule, value, callback), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 充电电费前置校验：允许为0，且最多4位小数；若大于0则不少于0.0001
    checkElectricCharge() {
      if (this.form.ruleType !== 1 || [2, 3].indexOf(this.form.type) === -1) return true
      const v = String(this.form.electricCharge || '').trim()
      if (!v) {
        this.$message.error('请输入充电电费')
        return false
      }
      const reg = /^(?:\d+)(?:\.\d{1,4})?$/
      if (!reg.test(v)) {
        this.$message.error('充电电费最多保留4位小数,第四位不为0')
        return false
      }
      const num = Number(v)
      if (!isFinite(num) || num < 0) {
        this.$message.error('请输入有效的非负数')
        return false
      }
      // 允许为 0；若大于 0，则最小为 0.0001
      if (num > 0 && num < 0.0001) {
        this.$message.error('充电电费大于0时，最小值为0.0001')
        return false
      }
      return true
    },

    // 提交前将充电电费规范为4位小数
    normalizeElectricCharge() {
      if (this.form.ruleType !== 1 || [2, 3].indexOf(this.form.type) === -1) return
      const v = this.form.electricCharge
      if (v === '' || v === null || v === undefined) return
      const num = Number(v)
      if (isFinite(num)) this.form.electricCharge = num.toFixed(4)
    },
    baseForm() {
      return {
        type: '',
        chargePlanPowerBeanList: []
      }
    },
    changeRuleType(value) {
      if (value === 2) this.form.type = 4
      else this.form.type = ''
    },
    handleParams() {
      let params = {}
      if (this.form.ruleType === 1) {
        params = {
          singelCharge: this.form.singelCharge,
          powerType: this.form.powerType,
          electricCharge: this.form.electricCharge,
          serviceCharge: this.form.serviceCharge,
          chargePlanPowerBeanList: this.form.chargePlanPowerBeanList
        }
      }
      if (this.form.ruleType === 2) {
        params = {
          freeDuration: this.form.freeDuration,
          chargeUpperLimit: this.form.chargeUpperLimit,
          chargePrice: this.form.chargePrice
        }
      }

      return {
        code: this.form.code,
        ruleType: this.form.ruleType,
        name: this.form.name,
        type: this.form.type,
        ...params
      }
    },
    // 表单规则校验函数：在表单项下方展示错误提示
    validateElectricChargeRule(rule, value, callback) {
      if (this.form.ruleType !== 1 || [2, 3].indexOf(this.form.type) === -1) return callback()
      const v = String(value || '').trim()
      if (!v) return callback(new Error('请输入充电电费'))
      const reg = /^(?:\d+)(?:\.\d{1,4})?$/
      if (!reg.test(v)) return callback(new Error('最多保留4位小数'))
      const num = Number(v)
      if (!isFinite(num) || num < 0) return callback(new Error('请输入有效的非负数'))
      // 允许为 0；若大于 0，则最小为 0.0001
      if (num > 0 && num < 0.0001) return callback(new Error('大于0时，最小值为0.0001'))
      return callback()
    },
    // 输入实时触发当前字段校验
    handleElectricChargeInput() {
      if (this.$refs && this.$refs['ruleForm']) this.$refs['ruleForm'].validateField('electricCharge')
    },
    handleUpdate() {
      updateFeeStandardApi(this.handleParams()).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    handleAdd() {
      addFeeStandardApi(this.handleParams()).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    open(opt) {
      const { type, row } = opt
      this.type = type
      if (type === 'created') this.form = this.baseForm()
      if(type === 'edit' || type === 'check') {
        feeStandardDetailApi({ code: row.code }).then((res) => {
          this.form = utils.deepCopy(res.data.result)
        })
      }
      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 200)
    },
    confirm() {
      // 仅做前置校验，不改变用户输入的小数位（例如 0.01 保持 0.01）
      if (!this.checkElectricCharge()) return
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.type === 'created' ? this.handleAdd() : this.handleUpdate()
        }
      })
    },
    handleRemove(i) {
      this.form.chargePlanPowerBeanList.splice(i, 1)
    },
    handleAddPlans() {
      const param = {
        price: '',
        maxPower: '',
        minPower: ''
      }
      this.form.chargePlanPowerBeanList.push(param)
    }
  }
}
</script>

<style lang="scss" scoped>
.form_item {
  margin-bottom: 20px;
  .label {
    width: 100px;
    flex-shrink: 0;
    margin-right: 10px;
    text-align: right;
  }
  .input {
    .el-input__inner {
      width: 300px !important;
    }
  }

  .price_wrapper {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding-left: 16px;
    .remove {
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
  }
}
</style>
